import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCalendar } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import smileyIcon from '../../assets/smiley.svg';
import './BottomNav.css';

const BottomNav = ({ 
  activeTab = 'calendar', 
  logo, 
  onMenuClick, 
  onLanguageClick, 
  onThemeClick, 
  theme, 
  isAuthenticated, 
  onLogout, 
  t: propT 
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const translationFunction = propT || t;

  return (
    <nav className="bottom-nav">
      {/* App Logo */}
      <div>
        {logo ? (
          <img src={logo} alt="Logo" className="app-logo-bottom" />
        ) : (
          <div className="brand-logo">
            <div className="logo-circle">o</div>
            <div className="brand-text">INDEL MONEY</div>
          </div>
        )}
      </div>

      {/* Calendar Icon */}
      <button
        className={`nav-item ${activeTab === 'calendar' ? 'active' : ''}`}
        onClick={() => navigate('/')}
      >
        <FaCalendar />
        <span>CALENDAR</span>
      </button>

      {/* Smiley Icon */}
      <button
        className={`nav-item ${activeTab === 'wishes' ? 'active' : ''}`}
        onClick={() => navigate('/wishes')}
      >
        <img src={smileyIcon} alt="Personalise" className="smiley-nav-icon" />
        <span>PERSONALISE</span>
      </button>

      {/* Hamburger Menu */}
      <button
        className="nav-item ext"
        onClick={onMenuClick || (() => {})}
      >
        <div className="menu-icon">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
    </nav>
  );
};

export default BottomNav;
